import requests from '../../../request'

const baseUrl = '/basedata/product/brand';
const selectorBaseUrl = '/selector';

/**
 * 品牌选择器查询
 */
export const selector = (params) => {
  return requests({
    url: selectorBaseUrl + '/brand',
    method: 'get',
    params
  });
}

/**
 * 根据ID批量加载品牌
 */
export const loadProductBrand = (data) => {
  return requests({
    url: selectorBaseUrl + '/brand/load',
    method: 'post',
    data
  });
}

/**
 * 查询列表
 */
export const query = (params) => {
  return requests({
    url: baseUrl + '/query',
    method: 'get',
    params
  });
}

/**
 * 根据ID查询
 * @param id
 */
export const get = (params) => {
  return requests({
    url: baseUrl,
    method: 'get',
    params
  });
}

/**
 * 批量停用
 * @param ids
 */
export const batchUnable = (data) => {
  return requests({
    url: baseUrl + '/unable/batch',
    method: 'patch',
    data
  });
}

/**
 * 批量启用
 * @param ids
 */
export const batchEnable = (data) => {
  return requests({
    url: baseUrl + '/enable/batch',
    method: 'patch',
    data
  });
}

/**
 * 新增
 * @param data
 */
export const create = (data) => {
  return requests({
    url: baseUrl,
    method: 'post',
    data
  },
    {
      contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
    });
}

/**
 * 修改
 * @param data
 */
export const update = (data) => {
  return requests({
    url: baseUrl,
    method: 'put',
    data
  },
    {
      contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
    });
}

/**
 * 下载导入模板
 */
export const downloadImportTemplate = () => {
  return requests({
    url: baseUrl + '/import/template',
    method: 'get',
    responseType: 'blob'
  });
}

/**
 * 导入
 */
export const importExcel = (data) => {
  return requests({
    url: baseUrl + '/import',
    method: 'post',
    data,
    responseType: 'blob'
  });
}